/**
 * @flow
 */
import React from "react";
import CircularProgress from '@material-ui/core/CircularProgress';
import {useSelector} from 'react-redux';
import Nav from '../../services/Nav';
import {ROUTE} from '../../settings';

const Home = (props) => {
  const user = useSelector((state) => state.user);
  React.useEffect(() => {
    if(user.id !== 0) {
      console.log('[Home] 사용자 로그인', {user});
      Nav.push(ROUTE.DASHBOARD_OVERVIEW);
    } else {
      console.log('[Home] 사용자 로그아웃', {user});
      Nav.push(ROUTE.SIGN_IN);
    }
  }, []);
  return (
    <div className="flex flex-center flex-middle w-100 h-100vh">
      <CircularProgress />
    </div>
  );
};

export default Home;
